import React from 'react'

import * as S from './styles'

/**
 * Slider Mantine v6; trilha (fundo) em `theme.cor27`.
 * Tooltip de valor desligado por padrão; passe `label` se quiser exibir de novo.
 * @param {import('@mantine/core').SliderProps} props
 */
export default function Slider({ color = 'teal', ...rest }) {
  return (
    <S.Slider
      color={color}
      label={null}
      showLabelOnHover={false}
      {...rest}
    />
  )
}
